<template>
  <div>
    <!-- show form to select pay period date and overview of order submissions for the selected date -->
    <div v-if="!enter_ts" class="row">
      <div class="col-12" v-if="!hide_date_picker">
        <ValidationObserver ref="registerWorkerForm" slim>
          <form role="form" @submit.prevent="enter_new_ts" class="row">
            <div class="col-12">
              <p><span class="red_color font-weight-bold" style="font-size: 1.15rem;">Please check the pay period below is
                  in line with the period you are submitting for.</span><br>
                It should be the start date for the period that you are looking to submit a payroll instruction for.<br>If
                it is not the date you are looking to submit for, please
                change the date to the correct period start date and select to close any pay periods open before the
                selected date.
              </p>
            </div>
            <div class="col-md-8">
              <p class="font-weight-bold cardLabel">Select the pay period for submission you are due to complete:</p>
            </div>
            <div class="col-md-4 offset-md-8 form-group" v-if="ts_submission_date !== null">
              <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Timesheet pay period end date"
                tag="div">
                <select class="form-control form-control-lg" v-model="selected" @change="select_ts_submission(selected.end_date)">
                    <option v-for="date in submissionWeeks" :value="date">{{ dateRange(date.start_date, date.end_date) }}</option>
                </select>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <button class="btn orcaBtn w-100 mt-2" type="submit">Select pay period for submission</button>
            </div>
            <div class="col-12 mt-4">
              <b-card v-if="selected" :header="'Submission Information for pay period: ' + dateRange(selected.start_date, selected.end_date)"
                header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <div class="col-12" v-if="ts_submission_date === null">
                    <p class="font-weight-bold">No information to display, please select a pay period date.</p>
                  </div>
                  <div class="col-12" v-else-if="submission_info.length === 0">
                    <order_loader :loadingMessage="'Submission Information'"></order_loader>
                  </div>
                  <div class="col-12" v-else>
                    <div class="row mb-2" v-for="(si, i) in submission_info">
                      <div class="col-lg-5">
                        <div class="row">
                          <div class="col-12">
                            <h4 class="mb-0 bp_color">{{ si.order_ref }} - {{ si.job_title }}</h4>
                            <p class="mb-2" v-if="si.alt_address_name">{{ si.alt_address_name }}</p>
                            <p class="mb-2" v-else>{{ si.job_address_full }}</p>
                          </div>
                          <div class="col-md-8"><span class="font-weight-bold">Total Workers</span></div>
                          <div class="col-md-4">{{ si.ts_records_length }}</div>
                          <div class="col-md-8"><span class="font-weight-bold">Total Order Cost</span></div>
                          <div class="col-md-4">{{ si.total_price | currency }}</div>
                          <div class="col-md-8"><span class="font-weight-bold">Total Retention Held</span></div>
                          <div class="col-md-4 mb-2">{{ si.retention_amount | currency }}</div>
                        </div>
                      </div>
                      <div class="col-lg-7 mb-3 mt-1 text-right">
                        <div class="chart">
                          <apexchart type="radialBar" height="125" :options="worker_chart_options"
                            :series="total_worker_submitted(si.ts_records_length, si.ts_records_worker_submitted)">
                          </apexchart>
                        </div>
                        <div class="chart">
                          <apexchart type="radialBar" height="125" :options="authorisation_chart_options"
                            :series="total_authorisations(si.ts_records_length, si.ts_records_company_submitted)">
                          </apexchart>
                        </div>
                        <div class="chart">
                          <apexchart type="radialBar" height="125" :options="submission_chart_options"
                            :series="total_company_submitted(si.ts_records_length, si.ts_records_company_submitted)">
                          </apexchart>
                        </div>
                      </div>
                      <div class="col-12">
                        <hr class="mt-0 mb-0" v-if="i !== Object.keys(submission_info).length - 1">
                      </div>

                    </div>

                  </div>
                </div>
              </b-card>
            </div>
          </form>
          <paginator v-if="this.showPagination" :p_pages="this.submission_info_pagination.pages"
            :p_parent_component="this.$options.name">
          </paginator>
        </ValidationObserver>
      </div>
      <div class="col-12" v-else>
        <p><span class="red_color font-weight-bold" style="font-size: 1.15rem;">There are currently no Timesheets Expected
            for submission.</span></p>
        <p>If this is not correct please contact <span v-if="crmType === 'payroll'">Genius</span><span
            v-if="crmType === 'recruitment'">V3</span></p>
      </div>
    </div>
    <!-- Show component for submitting timesheets for the selected pay period date -->
    <div v-if="enter_ts">
      <selected_period_submitter :company_name="company_name" :submission_date="selected"
        :timesheet_template_name="timesheet_template_name" :company_id="company_id"
        :timesheet_cycle_id="timesheet_cycle_id" v-if="submitterInitialised"
        v-on:reload-component="submitterInitialised = false"></selected_period_submitter>

    </div>
    <!-- modals for viewing worker submitted hours (fixed price) and for viewing worker submitted invoice -->
    <modal_show_hours v-if="$store.state.client_timesheets.show_hours_modal"></modal_show_hours>
    <modal_show_invoice v-if="$store.state.client_timesheets.show_invoice_modal"></modal_show_invoice>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueApexCharts from 'vue-apexcharts'
import selected_period_submit from "pages/clients/timesheets/selected_period_submit";
import selected_period_submitter from "pages/clients/timesheets/selected_period_submitter";
import order_loader from "loaders/order_loader";
import modal_show_hours from 'components/pages/clients/timesheets/modals/show_hours';
import modal_show_invoice from 'components/pages/clients/timesheets/modals/show_invoice';
import paginator from 'components/pages/paginator/paginator';
import Multiselect from "vue-multiselect";

export default {
  name: "c_timesheet_submit",
  components: {
    Datepicker,
    selected_period_submit,
    selected_period_submitter,
    apexchart: VueApexCharts,
    modal_show_hours,
    modal_show_invoice,
    Multiselect,
    order_loader,
    paginator
  },
  data() {
    return {
      submitterInitialised: true,
      company_id: null,
      company_name: null,
      timesheet_cycle_id: null,
      timesheet_template_name: null,
      original_ts_submission_date: null,
      ts_submission_date: null,
      selected: null,
      selected_date: null,
      disable_dates: {
        days: [],
        from: '',
        to: ''
      },
      enter_ts: false,
      submission_info: [],
      submission_info_pagination: {
        page: 0,
        pages: 0
      },
      showPagination: false,
      worker_chart_options: {
        chart: {
          // height: 125,
          width: '100%',
          type: 'radialBar',
          offsetY: -10,
          redrawOnParentResize: true,
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '12px',
                color: undefined,
                offsetY: 58
              },
              value: {
                offsetY: 26,
                fontSize: '16px',
                color: undefined,
                formatter: function (val) {
                  return parseFloat(val).toFixed(2) + '%';
                }
              }
            },
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          },
        },
        stroke: {
          dashArray: 4
        },
        labels: ['Worker Submitted'],
      },
      authorisation_chart_options: {
        chart: {
          // height: 125,
          width: '100%',
          type: 'radialBar',
          offsetY: -10,
          redrawOnParentResize: true,
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '12px',
                color: undefined,
                offsetY: 58
              },
              value: {
                offsetY: 26,
                fontSize: '16px',
                color: undefined,
                formatter: function (val) {
                  return parseFloat(val).toFixed(2) + '%';
                }
              }
            },
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          },
        },
        stroke: {
          dashArray: 4
        },
        labels: ['Your Authorisations'],
      },
      submission_chart_options: {
        chart: {
          // height: 125,
          width: '100%',
          type: 'radialBar',
          offsetY: -10,
          redrawOnParentResize: true,
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '12px',
                color: undefined,
                offsetY: 58
              },
              value: {
                offsetY: 26,
                fontSize: '16px',
                color: undefined,
                formatter: function (val) {
                  return parseFloat(val).toFixed(2) + '%';
                }
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          },
        },
        stroke: {
          dashArray: 4
        },
        labels: ['Submitted to Genius'],
      },

      hide_date_picker: false,
    }
  },
  computed: {
    formatted_ts_submission_date() {
      if (this.ts_submission_date !== null) {
        return this.$options.filters.formatDate(this.ts_submission_date)
      }
      else {
        return 'No Date Selected'
      }
    }
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    submitterInitialised(val) {
      // Always reload the submitter automatically
      if (val === false) {
        this.$nextTick(() => this.submitterInitialised = true);

      }
    },
  },
  methods: {
    reload(p) {
      // page starts with 0
      this.submission_info_pagination.page = p;
      this.submission_info = [];
      this.getData();
    },
    /* Date Format for datepicker */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    dateRange(d1, d2) {
      return this.$moment.utc(d1).format('DD/MM/YYYY') + ' - ' + this.$moment.utc(d2).format('DD/MM/YYYY');
    },
    // Select actions on datepicker/multiselect
    select_ts_submission(selected_date) {
      if (selected_date !== null) {

        if (this.$store.state.auth.me.roles.includes('client_sub')) {
          if (this.$moment.utc(selected_date).format('YYYY-MM-DD') > this.original_ts_submission_date) {
            // this.$snotify.confirm('', '', {
            //   closeOnClick: false,
            //   position: 'centerCenter',
            //   backdrop: 0.5,
            //   html: '<div class="snotifyToast__title">Close Previous Pay Period</div>' +
            //     '<div class="snotifyToast__body">' +
            //     'There are timesheets for locations in pay periods prior to ' +
            //     this.$moment.utc(selected_date).format('DD/MM/YYYY') + ' which have not been submitted to ' + this.crmCompany +
            //     '.<br><br>' +
            //     'Clicking OK will close these periods to any further entry.' +
            //     '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            //     '</div>',
            //   buttons: [
            //     {
            //       text: 'Ok', action: (toast) => {
            //         axios.post(this.crmApiPath + 'timesheet/close_pay_periods', {
            //           company_id: this.company_id,
            //           prior_to: this.$moment.utc(selected_date).format('YYYY-MM-DD')
            //         }).then(() => {
            //           // Set and disable dates based on previously submitted timesheets by the client
            //           axios.get(this.crmApiPath + 'timesheet/submission_weeks/' + this.company_id).then(res => {
            //             this.submissionWeeks = res.data.data.days;
            //             this.selected = this.submissionWeeks[0];
            //             this.disable_dates.to = new Date(this.$moment.utc(this.selected.end_date).format('YYYY-MM-DD'))
            //             this.disable_dates.from = new Date(this.$moment.utc(this.submissionWeeks[this.submissionWeeks.length - 1].end_date).format('YYYY-MM-DD'))
            //             this.ts_submission_date = this.$moment.utc(selected_date).format('YYYY-MM-DD');
            //             this.original_ts_submission_date = this.$moment.utc(this.selected.end_date).format('YYYY-MM-DD');
            //             this.get_week_starting_info(this.$moment.utc(selected_date).format('YYYY-MM-DD'));
            //           });
            //           this.$snotify.remove(toast.id);
            //         })
            //       }
            //     },
            //     {
            //       text: 'Cancel', action: (toast) => {
            //         this.selected = this.submissionWeeks[0];
            //         let endDate = this.selected.end_date;
            //         this.ts_submission_date = endDate;
            //         this.$snotify.remove(toast.id)
            //       }
            //     }
            //   ]
            // });
            this.ts_submission_date = this.$moment.utc(selected_date).format('YYYY-MM-DD');
            this.get_week_starting_info(selected_date);
          }
          else {
            this.ts_submission_date = this.$moment.utc(selected_date).format('YYYY-MM-DD');
            this.get_week_starting_info(selected_date);
          }
        }
        else {
          this.ts_submission_date = this.$moment.utc(selected_date).format('YYYY-MM-DD');
          this.get_week_starting_info(selected_date);
        }
      }
    },
    get_week_starting_info_first() {
      this.submission_info_pagination.page = 0;
      this.get_week_starting_info(this.selected_date);
    },
    get_week_starting_info_previous() {
      if (this.submission_info_pagination.pages > 0) {
        if (this.submission_info_pagination.page > 0) {
          this.submission_info_pagination.page--;

          this.get_week_starting_info(this.selected_date);
        }
      }
    },
    get_week_starting_info_next() {
      if (this.submission_info_pagination.pages > 0) {
        if (this.submission_info_pagination.page < this.submission_info_pagination.pages) {
          this.submission_info_pagination.page++;

          this.get_week_starting_info(this.selected_date);
        }
      }
    },
    get_week_starting_info_last() {
      if (this.submission_info_pagination.pages > 0) {
        this.submission_info_pagination.page = this.submission_info_pagination.pages - 1;

        this.get_week_starting_info(this.selected_date);
      }
    },
    get_week_starting_info(selected_date) {

      this.selected_date = selected_date;

      return axios.get(this.crmApiPath + 'timesheet/week_starting_info/get/' + this.$store.state.auth.me.contact_id, {
        params: {
          week_end_date: this.$moment.utc(selected_date).format('YYYY-MM-DD'),
          page_length: 5,
          page: this.submission_info_pagination.page
        }
      }).then(res => {
        this.submission_info = res.data.data
        this.submission_info_pagination.page = res.data.pagination.page;
        this.submission_info_pagination.pages = res.data.pagination.pages;
        this.showPagination = true;
      }
      )
    },
    total_worker_submitted(total, ws) {
      return ws !== 0 ? [(ws * 100) / total] : [0];
    },
    total_authorisations(total, ta) {
      return ta !== 0 ? [(ta * 100) / total] : [0];
    },
    total_company_submitted(total, cs) {
      return cs !== 0 ? [(cs * 100) / total] : [0];
    },
    enter_new_ts() {
      // axios.post(this.crmApiPath + 'timesheet/close_pay_periods', {
      //   company_id: this.company_id,
      //   prior_to: this.$moment.utc(this.ts_submission_date).format('YYYY-MM-DD')
      // }).then(() => {
      //   this.enter_ts = true;
      // });
      this.enter_ts = true;
    },
    getData() {
      axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
        this.timesheet_template_name = company.data.timesheet_template_name;
        this.company_id = company.data.id;
        this.company_name = company.data.company_name;
        this.timesheet_cycle_id = company.data.rel_payment_process_info.timesheet_cycle_id;

        // Set and disable dates based on previously submitted timesheets by the client
        axios.get(this.crmApiPath + 'timesheet/submission_weeks/' + company.data.id).then(res => {

          this.submissionWeeks = res.data.data.days;
          if (this.submissionWeeks.length > 0) {
            this.disable_dates.to = this.$moment.utc(this.submissionWeeks[0].end_date, 'YYYY-MM-DD').subtract(7, 'days').toDate();
            this.disable_dates.from = this.$moment.utc(this.submissionWeeks[this.submissionWeeks.length - 1].end_date, 'YYYY-MM-DD').toDate();
            this.select_ts_submission(this.$moment.utc(this.submissionWeeks[0].end_date).format('YYYY-MM-DD'));
            this.original_ts_submission_date = this.$moment.utc(this.submissionWeeks[0].end_date).format('YYYY-MM-DD');
            this.ts_submission_date = this.$moment.utc(this.submissionWeeks[0].end_date).format('YYYY-MM-DD');
            this.selected = this.submissionWeeks[0];
          }
          else {
            this.hide_date_picker = true;
          }
        });

        axios.get(this.crmApiPath + 'company/payment_process_info/company/' + company.data.id).then(payment_process_info => {

          if (payment_process_info.data.pay_week_start_day === 'Monday') {
            this.disable_dates.days = [0, 2, 3, 4, 5, 6];
          }

          if (payment_process_info.data.pay_week_start_day === 'Tuesday') {
            this.disable_dates.days = [0, 1, 3, 4, 5, 6];
          }

          if (payment_process_info.data.pay_week_start_day === 'Wednesday') {
            this.disable_dates.days = [0, 1, 2, 4, 5, 6];
          }

          if (payment_process_info.data.pay_week_start_day === 'Thursday') {
            this.disable_dates.days = [0, 1, 2, 3, 5, 6];
          }

          if (payment_process_info.data.pay_week_start_day === 'Friday') {
            this.disable_dates.days = [0, 1, 2, 3, 4, 6];
          }

          if (payment_process_info.data.pay_week_start_day === 'Saturday') {
            this.disable_dates.days = [0, 1, 2, 3, 4, 5];
          }

          if (payment_process_info.data.pay_week_start_day === 'Sunday') {
            this.disable_dates.days = [1, 2, 3, 4, 5, 6];
          }
        })
      });
    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  max-width: 140px;
  width: 140px;
  display: inline-block;
  margin: 0 5px;
}

.chart,
.chart-box {
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 22px 35px -16px rgb(0 0 0 / 10%);
}
</style>
